import { render, staticRenderFns } from "./search2.vue?vue&type=template&id=703bf375&scoped=true"
import script from "./search2.vue?vue&type=script&lang=js"
export * from "./search2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "703bf375",
  null
  
)

export default component.exports